import React, { useEffect, useState } from 'react';
import Header from "../../../../components/Headers/BasicHeader";
import '../Index.css'
import Paginations from '../../../../components/Pagination/BasicPagination';
import { useNavigate } from "react-router-dom";
import { setDataOnGrid, applySearch } from '../../../../utils/views/pages/Dynamics'
import { format } from 'date-fns';

import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    Table,
    Form,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup,
    Button,
    Spinner
} from "reactstrap";
import { getSubscriptions } from "../../../../network/ApiAxios";
import secureLocalStorage from "react-secure-storage";
import {periodLabels} from '../../../../utils/views/pages/StaticPatterns'

const Subscriptions = () => {

    const [subscriptions, setSubscriptions] = useState([]);
    const [subscriptionsBackup, setSubscriptionsBackup] = useState([]);
    const [reloadData, setReloadData] = useState(false)
    const [itemsPerPage, setItemsPerPage] = useState(process.env.REACT_APP_PAGE_ITEMS)
    const [currentPage, setCurrentPage] = useState(1)
    const [searchKey, setSearchKey] = useState('')
    const [foundRegisters, setFoundRegisters] = useState()
    const [loadingId, setLoadingId] = useState('')
    const [isLoading, setisLoading] = useState(false)

    const [sortField, setSortField] = useState('')
    const [sortDirection, setSortDirection] = useState('asc')

    const user = JSON.parse(secureLocalStorage.getItem("user"));
    const app = JSON.parse(secureLocalStorage.getItem("app"));
    const navigate = useNavigate();
    const searchFields = ['date', 'plan.name', 'plan.periodicity', 'licensesLimit']
    const [searchAction, setSearchAction] = useState(false)
    
    /**
     * Carregamento dos dados principais para alimentar o grid 
     * Alimenta os objetos que permitirão realizar buscas e filtragens
     * dinamicamente
     */
    useEffect(() => {
        const runAsync = async () => {
            setisLoading(true);
            
            let params = {
                filter: { account: user.account },
                constraint: { app: app._id }
            }

            const response = await getSubscriptions(params);
            const { data } = response;

            if (data.success) {
                setFoundRegisters(data.subscriptions?.length)

                const sortedData = applySorting(data.subscriptions);
                setDataOnGrid(sortedData, setSubscriptions, currentPage, itemsPerPage);
                setSubscriptionsBackup(data.subscriptions);
                setReloadData(false);
                setLoadingId('');
                setisLoading(false);

            }
        }
        runAsync();
    }, [reloadData]);


    /**
     * Gatilho que captura situações onde devemos realizar busca de dados de acordo com 
     * filtro e reordenar os dados para mostrar no grid
     */
    useEffect(() => {
        if(!searchAction){
        applySearch(searchKey, searchFields, setSubscriptions, subscriptionsBackup, setFoundRegisters, currentPage, itemsPerPage, true);
        const sortedData = applySorting(subscriptionsBackup);
        setDataOnGrid(sortedData, setSubscriptions, currentPage, itemsPerPage);
        } else {
            setSearchAction(false)
        }

    }, [sortField, sortDirection, searchKey, currentPage, itemsPerPage])

    /**
     * Ordena os dados do grupo de acordo com a coluna e direção
     * escolhida pela usuário
     * 
     * @param {*} data 
     * @param {*} field 
     * @param {*} direction 
     * @returns 
     */
    const sortData = (data, field, direction) => {
        if (!field) return data;

        const getNestedValue = (obj, path) => {
            return path.split('.').reduce((acc, part) => acc && acc[part], obj);
        }

        return [...data].sort((a, b) => {
            let aValue = getNestedValue(a, field) || '';
            let bValue = getNestedValue(b, field) || '';
            if (typeof aValue === 'string') aValue = aValue.toLowerCase();
            if (typeof bValue === 'string') bValue = bValue.toLowerCase();

            if (direction === 'asc') {
                //Para ordem crescrente
                return aValue > bValue ? 1 : -1;
            } else {
                //Para ordem decrescente
                return aValue < bValue ? 1 : -1;
            }
        })

    }

    const applySorting = (data) => {
        if (!sortField) return data;
        return sortData(data, sortField, sortDirection);
    }

    let handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
        setCurrentPage(1);
    }

    let handleSearch = (e) => {
        setSearchAction(true)
        setSearchKey(e.target.value)
        applySearch(e.target.value, searchFields, setSubscriptions, subscriptionsBackup, setFoundRegisters, currentPage, itemsPerPage, true);
    }

    let formatDate = (date) => {
        let formDate = date ? format(date, "yyyy-MM-dd") : ''

        return formDate
    }    

    return (
        <>
            <Header></Header>

            <Container>
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <CardHeader className="border-0 pb-3 pt-3 pt-md-3">

                                <Row id="headerOptions" className=''>

                                    <Col lg="8" md="8">
                                        <Form className="navbar-search-light form-inline mr-3 d-none d-md-flex  w-100   ">
                                            <FormGroup className="mb-0 w-100 ">
                                                <InputGroup id="search-input" className="input-group-alternative w-100 ">

                                                    <InputGroupAddon addonType="prepend" className='w-100'>
                                                        <InputGroupText >
                                                            <i className="fas fa-search" />
                                                        </InputGroupText>
                                                        <Input value={searchKey} onChange={handleSearch} className='w-100' placeholder="Search" type="text" />
                                                    </InputGroupAddon>

                                                </InputGroup>
                                            </FormGroup>
                                        </Form>
                                    </Col>
                                    <Col id='addButton' lg="4" md="4">
                                        <Button onClick={() => navigate(`/${app.alias}`)}
                                            className="btn-icon btn-3" color="primary" type="button">

                                            <span className="btn-inner--text">Buy a new subscription</span>

                                            <span className="btn-inner--icon">
                                                <i className="ni ni-fat-add" />
                                            </span>

                                        </Button>
                                    </Col>

                                </Row>
                            </CardHeader>

                            {isLoading && !loadingId ? (
                                <div className="text-center p-5">
                                    <Spinner size="lg" />
                                </div>

                            ) : (


                                <Table className="align-items-center table-flush" responsive>
                                    <thead >
                                        <tr>                                            
                                            <th scope="col"
                                                onClick={() => handleSort('plan.name')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'plan.name' ? 'table-header-sorted' : ''}
                                            >
                                                Plan

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />


                                            </th>
                                            <th scope="col"
                                                onClick={() => handleSort('plan.periodicity')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'plan.periodicity' ? 'table-header-sorted' : ''}
                                            >
                                                Periodicity

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />


                                            </th>
                                            <th scope="col"
                                                onClick={() => handleSort('licensesLimit')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'licensesLimit' ? 'table-header-sorted' : ''}
                                            >
                                                Licenses

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />


                                            </th>
                                            <th scope="col"
                                                onClick={() => handleSort('consumedLicenses')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'consumedLicenses' ? 'table-header-sorted' : ''}
                                            >
                                                Consumed Licenses

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />


                                            </th>
                                            <th scope="col"
                                                onClick={() => handleSort('date')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'date' ? 'table-header-sorted' : ''}
                                            >
                                                Start Date

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />


                                            </th>
                                            <th scope="col" >Status </th>
                                            <th scope="col" className='text-right'>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {subscriptions.map(subscription => (
                                            <tr key={subscription._id}>
                                                
                                                <td scope="row">  {subscription.plan?.name} </td>
                                                <td scope="row">  {periodLabels[subscription.plan?.periodicity]} </td>
                                                <td scope="row">  {subscription.licensesLimit} </td>
                                                <td scope="row">  {subscription.consumedLicenses} </td>
                                                <td scope="row">  {formatDate(subscription.date)} </td>
                                                <td scope="row">  {subscription.active? 'Active': 'Expired'} </td>
                                                <td className='text-right'>
                                                   
                                                    <Button className="btn-icon action" color="success" type="button"
                                                        onClick={() => navigate('/admin/subscription/view/' + subscription._id)}
                                                        disabled={loadingId === subscription._id}

                                                    >

                                                        <span className="btn-inner--icon">
                                                            <img
                                                                id="view-button"
                                                                alt="view"
                                                                src={require("assets/img/icons/common/eye-button.svg").default}
                                                            />
                                                        </span>

                                                    </Button>




                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>


                            )}
                        </Card>
                    </div>
                </Row>

                <Row className='pt-md-3'>
                    <Col>
                        <span className="h5 itens-quantity">
                            {subscriptionsBackup?.length} subscriptions
                        </span>
                    </Col>
                    <Col>
                        <Paginations
                            itemsPerPage={itemsPerPage}
                            totalItems={foundRegisters}
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                        />

                    </Col>
                </Row>

            </Container>

        </>

    );
}

export default Subscriptions;
